import { apiService } from './api';
import { PaginationParams } from '../types';

export interface VehicleCategoryDTO {
  id: number;
  name: string;
  description?: string;
  isActive: boolean;
}

export interface VehicleDTO {
  id: number;
  vehicleNumber: string;
  registrationNumber: string;
  vin?: string;
  make: string;
  model: string;
  year: number;
  vehicleCategoryId: number;
  vehicleCategoryName?: string;
  color?: string;
  seatingCapacity: number;
  fuelType: 'Petrol' | 'Diesel' | 'Electric' | 'Hybrid' | 'LPG';
  transmission: 'Manual' | 'Automatic';
  mileage: number;
  rentalRate: number;
  securityDeposit: number;
  gpsAvailable: boolean;
  insuranceDetails?: string;
  status: 'Available' | 'Reserved' | 'Rented' | 'UnderMaintenance' | 'Damaged' | 'Retired';
  isActive: boolean;
  createdAt: string;
}

export interface CreateVehicleRequest {
  vehicleNumber: string;
  registrationNumber: string;
  vin?: string;
  make: string;
  model: string;
  year: number;
  vehicleCategoryId: number;
  color?: string;
  seatingCapacity: number;
  fuelType: string;
  transmission: string;
  mileage: number;
  rentalRate: number;
  securityDeposit: number;
  gpsAvailable: boolean;
  insuranceDetails?: string;
  isActive: boolean;
}

export interface UpdateVehicleRequest extends CreateVehicleRequest {
  status: string;
}

const API = '/car-rental/vehicles';

export const vehicleService = {
  getAll: (params: PaginationParams = {}) =>
    apiService.get<VehicleDTO[]>(API, { pageNumber: params.pageNumber || 1, pageSize: params.pageSize || 100 }),

  getById: (id: number) => apiService.get<VehicleDTO>(`${API}/${id}`),

  searchAvailable: (pickupDate: string, returnDate: string) =>
    apiService.get<VehicleDTO[]>(`${API}/search`, { pickupDate, returnDate }),

  getCategories: () => apiService.get<VehicleCategoryDTO[]>(`${API}/categories`),

  createCategory: (name: string, description?: string) =>
    apiService.post<VehicleCategoryDTO>(`${API}/categories`, { name, description, isActive: true }),

  create: (data: CreateVehicleRequest) => apiService.post<VehicleDTO>(API, data),

  update: (id: number, data: UpdateVehicleRequest) => apiService.put<VehicleDTO>(`${API}/${id}`, data),

  delete: (id: number) => apiService.delete<boolean>(`${API}/${id}`),
};
